import "./Calculator.scss";
import { useState, useCallback, useEffect } from "react";
// import InfoBlock from "components/InfoBlock/InfoBlock";
import FormContainer from "components/FormContainer/FormContainer";
import ExchangeCalculator from "components/ExchangeCalculator/ExchangeCalculator";
import EmailPopup from "components/PopUps/EmailPopup/EmailPopup";
import { useAppSelector, useAppDispatch } from "store";
import { exchangeActions } from "../../store/reducers/exchange";
import { confirmEmail } from "../../store/reducers/signIn";
import Verification from "components/Verification/Verification";
import FinishedModal from "components/PopUps/FinishedModal/FinishedModal";
import PEPPopup from "components/PopUps/PEPPopup/PEPPopup";
import ErrorPopup from "components/PopUps/ErrorPopup/ErrorPopup";
import VerificationErrorPopup from "components/PopUps/ErrorPopup/VerificationErrorPopup";
import {
  getKYCKYBStatus,
  checkPasswordStatus,
  getKYCAddressURL,
} from "store/reducers/exchange";
import SignIn from "components/SignInSections/SignIn";
import ForgotPassword from "components/SignInSections/ForgotPassword/ForgotPassword";
import OTCContact from "components/OTCContact/OTCContact";
import { useTranslation } from "react-i18next";

export enum ClientType {
  Individual = "Individual",
  Business = "Business",
}
type ComponentKeys =
  | "ExchangeCalculator"
  | "FormContainer"
  | "Verification_Error"
  | "Verification"
  | "Verification_SOF"
  | "FinishedPopup"
  | "SignIn"
  | "ForgotPassword";

const Calculator = () => {
  const [clientType, setClientType] = useState<ClientType>(
    ClientType.Individual
  );
  const isIndividualClient = clientType === ClientType.Individual;
  const tabArray = Object.values(ClientType);
  const {
    isErrorEmail,
    componentsName,
    isOpenPEPPopUp,
    isOpenServerErrorPopup,
    KYCUrlForm,
  } = useAppSelector((state) => state.exchange);
  const { isOpenServerErrorPopupSignIn } = useAppSelector(
    (state) => state.signIn
  );
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();

  const urlParams = new URLSearchParams(window.location.search);
  const form = urlParams.get("form") || "";
  const requestId = urlParams.get("requestId") || "";
  const token = urlParams.get("token") || "";
  const verify_email = urlParams.get("verify_email") || "";
  const language = urlParams.get("lng") || i18n.language;
  const userId = urlParams.get("userId") || "";

  const getStatus = useCallback(async () => {
    return await dispatch(getKYCKYBStatus({ id: Number(requestId) })).unwrap();
  }, [dispatch, requestId]);

  const checkPassword = useCallback(async () => {
    return await dispatch(checkPasswordStatus({ clientId: userId })).unwrap();
  }, [dispatch, userId]);

  useEffect(() => {
    if (language !== i18n.language) {
      i18n.changeLanguage(language).catch((error) => {
        console.error("Error changing language:", error);
      });
    }
  }, [language, i18n]);

  useEffect(() => {
    if (requestId) {
      const checkStatus = async () => {
        try {
          const status = await getStatus();
          if (
            status.isKycKybVerified &&
            !status.needSof &&
            status.currentStatus == "KYC_CRYPTO_ADDRESS_VERIFIED"
          ) {
            clearInterval(intervalId);
          } else if (!status.needKycAddress) {
            const status = await checkPassword();
            if (!status.hasPassword) {
              window.location.href = "/set-up-password?userId=" + userId;
            } else {
              window.location.href = "/?form=sign";
              clearInterval(intervalId);
            }
          } else if (status.needKycAddress) {
            dispatch(
              getKYCAddressURL({
                clientId: userId,
                requestId: requestId,
              })
            );
          }
        } catch (error) {
          clearInterval(intervalId);
        }
      };
      checkStatus();
      const intervalId = setInterval(checkStatus, 5000);
      return () => clearInterval(intervalId);
    }
    if (form === "sign") {
      dispatch(exchangeActions.setComponentsName("SignIn"));
    }
    if (verify_email === "true" && !!token.length) {
      dispatch(confirmEmail({ token: token }));
    }
  }, [requestId, dispatch]);

  useEffect(() => {
    if (KYCUrlForm) {
      window.location.href = KYCUrlForm;
    }
  }, [KYCUrlForm, dispatch]);

  const closeErrorEmail = useCallback(() => {
    dispatch(exchangeActions.setCloseErrorEmail());
  }, [dispatch]);

  const closePEPPopUp = useCallback(() => {
    dispatch(exchangeActions.setIsOpenPEPPopUp(false));
  }, [dispatch]);

  const componentsMap: Record<ComponentKeys, JSX.Element> = {
    ExchangeCalculator: (
      <ExchangeCalculator
        clientType={clientType}
        setClientType={setClientType}
        tabArray={tabArray}
        isIndividualClient={isIndividualClient}
      />
    ),
    FormContainer: (
      <>
        <FormContainer isIndividualClient={isIndividualClient} />
        {/* <InfoBlock isIndividualClient={isIndividualClient} /> */}
        <OTCContact />
      </>
    ),
    Verification: (
      <Verification
        isIndividualClient={isIndividualClient}
        isSOFVerification={false}
      />
    ),
    Verification_SOF: (
      <Verification
        isIndividualClient={isIndividualClient}
        isSOFVerification={true}
      />
    ),
    FinishedPopup: <FinishedModal />,
    Verification_Error: <VerificationErrorPopup />,
    SignIn: <SignIn />,
    ForgotPassword: <ForgotPassword />,
  };

  return (
    <div
      className={
        componentsName == "ExchangeCalculator"
          ? "calculator-container first-step"
          : "calculator-container"
      }
    >
      {componentsName == "ExchangeCalculator" && (
        <div className="calculator-header">
          <h1 className="main-title">{t("subtitles.exchangeSubtitle1")}</h1>
          <div className="sub-title">{t("subtitles.exchangeSubtitle2")}</div>
        </div>
      )}
      <div className="form-area">
        {isErrorEmail && <EmailPopup closeErrorEmail={closeErrorEmail} />}
        {componentsMap[componentsName as ComponentKeys]}
      </div>
      {componentsName == "ExchangeCalculator" && <OTCContact />}
      {isOpenPEPPopUp && <PEPPopup onClick={closePEPPopUp} />}
      {(isOpenServerErrorPopup || isOpenServerErrorPopupSignIn) && (
        <ErrorPopup />
      )}
    </div>
  );
};

export default Calculator;
